/**
 * The object that need to be checked
 *
 * @param {object} obj
 */
export const cleanUndefinedFromObject = (obj) => {
  Object.keys(obj).forEach((key) =>
    obj[key] === undefined ? delete obj[key] : {}
  )

  return obj
}
